import { dayFormatted } from '../../../utils/helpers'

export const useAttendedRequest = (results, chartType) => {
  const attendStatus = results.attend_status || {}
  const daysToHandle = results.days_to_handle || {}

  const chartData = {
    PieChart: [
      ['Tiempo de atención', 'Cantidad'],
      ['Pendiente: Dentro de plazo', attendStatus.pending_on_time || 0],
      ['Pendiente: Fuera de plazo', attendStatus.pending_late || 0],
      ['Dentro del plazo', attendStatus.on_time || 0],
      ['Fuera del plazo', attendStatus.late || 0]
    ],
    BarChart: [
      ['Número de solicitudes', ...Object.keys(daysToHandle).map(el => dayFormatted(el))],
      ['', ...Object.values(daysToHandle)]
    ]
  }

  const chartTitle = {
    PieChart: {
      title: 'Porcentaje de atención de solicitudes dentro del plazo',
      chartTitle: 'Porcentaje de solicitudes atendidas dentro del plazo',
      description:
        'Visualiza el porcentaje de atención de solicitudes por formulario, que fueron atendidas dentro del plazo meta.'
    },
    BarChart: {
      title: 'Tiempos de atención de solicitudes',
      chartTitle: 'Distribución de tiempos de atención',
      description: 'Visualiza la atención de solicitudes por formulario.'
    }
  }

  return {
    chartData: chartData[chartType],
    chartTitle: chartTitle[chartType]
  }
}
